import { reactive, watch } from "vue"

export const useErrors = (values: any) => {

  const errors = reactive<any>({})

  const oldValues: { [key: string]: string } = {}
  watch(values, () => {
    for (let [ key, value ] of Object.entries(values)) {
      if (errors[key] && value !== oldValues[key]) {
        delete errors[key]
      }
    }
    Object.assign(oldValues, values)
  })

  return errors
}